import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
// @mui
import { Container, Typography, Box, Alert, AlertTitle, Button } from '@mui/material';
// components
import { useNavigate } from 'react-router-dom';
import { SubscriptionList } from '../sections/@dashboard/subscriptions';
import { useAppContext } from '../context';
import { openBillingPortal, paymentIssueMessage } from '../utils/billing';

// ----------------------------------------------------------------------

// Helper function to format dates in French
const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
};

export default function SubscriptionsPage() {
  const { user } = useAppContext();
  const navigate = useNavigate();
  const [portalError, setPortalError] = useState(null);
  const [portalLoading, setPortalLoading] = useState(false);

  useEffect(() => {
    if (!user) {
      navigate('/login', { replace: true });
    }
  }, [user, navigate]);

  const subscriptionState = user?.user?.subscriptionState;
  const paymentIssue = paymentIssueMessage(subscriptionState);

  const handleOpenPortal = async () => {
    setPortalError(null);
    setPortalLoading(true);
    try {
      await openBillingPortal(user.jwt);
    } catch (error) {
      setPortalError(error.message);
      setPortalLoading(false);
    }
  };

  const subscriptions = [
    {
      id: 1,
      name: 'Abonnement 1 mois',
      monthlyRate: 150,
      totalPrice: 150,
      duration: '1 mois',
      url: 'https://buy.stripe.com/4gM3cw6AF8W86Jddnz2wU0a', // To be filled later
      img: '/assets/images/products/1month.jpeg',
    },
    {
      id: 2,
      name: 'Abonnement 3 mois',
      monthlyRate: 130,
      totalPrice: 390,
      duration: '3 mois',
      url: 'https://buy.stripe.com/7sY4gA4sxb4g4B5abn2wU07', // To be filled later
      img: '/assets/images/products/3months.jpeg',
    },
    {
      id: 3,
      name: 'Abonnement 6 mois',
      monthlyRate: 120,
      totalPrice: 720,
      duration: '6 mois',
      url: 'https://buy.stripe.com/14A8wQ4sxfkw9Vp97j2wU08', // To be filled later
      img: '/assets/images/products/6months.jpeg',
    },
    {
      id: 4,
      name: 'Abonnement 12 mois',
      monthlyRate: 100,
      totalPrice: 1200,
      duration: '12 mois',
      url: 'https://buy.stripe.com/cNi6oI1glegsgjN6Zb2wU09', // To be filled later
      img: '/assets/images/products/12months.jpeg',
    },
  ];

  return (
    <>
      <Helmet>
        <title>Abonnements : Gino Boxing</title>
      </Helmet>

      <Container>
        <Typography variant="h4" sx={{ mb: 5 }}>
          Abonnements
        </Typography>

        {paymentIssue && (
          <Alert
            severity={paymentIssue.severity}
            sx={{ mb: 3 }}
            action={
              subscriptionState?.canManageBilling && (
                <Button color="inherit" size="small" disabled={portalLoading} onClick={handleOpenPortal}>
                  Mettre à jour ma carte
                </Button>
              )
            }
          >
            <AlertTitle>{paymentIssue.title}</AlertTitle>
            {paymentIssue.body}
          </Alert>
        )}

        {portalError && (
          <Alert severity="error" sx={{ mb: 3 }}>
            {portalError}
          </Alert>
        )}

        {user?.user?.subs && !paymentIssue && (
          <Box sx={{ mb: 3, p: 3, bgcolor: 'primary.main', borderRadius: 1, border: '2px solid', borderColor: 'primary.dark' }}>
            <Typography variant="h6" sx={{ color: '#000', fontWeight: 600 }}>
              Abonnement actif
            </Typography>
            <Typography variant="body2" sx={{ color: '#000', fontWeight: 500 }}>
              Du {formatDate(user.user.subs.buyDate)} au {formatDate(user.user.subs.endDate)}
            </Typography>
            {subscriptionState?.canManageBilling && (
              <Button
                size="small"
                sx={{ mt: 1, color: '#000', textDecoration: 'underline' }}
                disabled={portalLoading}
                onClick={handleOpenPortal}
              >
                Gérer mon abonnement
              </Button>
            )}
          </Box>
        )}

        <SubscriptionList subscriptions={subscriptions} />
      </Container>
    </>
  );
}
